import { Toggle } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './TwoOptionToggle.module.scss'

const propTypes = {
  /**
   * If true, the toggle is checked
   */
  checked: PropTypes.bool,
  /**
   * Callback when the toggle is changed. Receives the checked as argument
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Label to show when the toggle is off. React node
   */
  offLabel: PropTypes.node,
  /**
   * Label to show when the toggle is off. react-intl message id
   */
  offLabelId: PropTypes.string,
  /**
   * Label to show when the toggle is on. React node
   */
  onLabel: PropTypes.node,
  /**
   * Label to show when the toggle is on. react-intl message id
   */
  onLabelId: PropTypes.string,
  /**
   * id of the toggle
   */
  id: PropTypes.string,
  /**
   * Class to override default styles of the container
   */
  containerClass: PropTypes.string,
}

/**
 * Toggle switch with labels on both sides. Appears always 'on' independently of the side it's pointing to.
 */
function TwoOptionToggle(props) {
  const {
    checked = false,
    offLabel = null,
    offLabelId = '',
    onLabel = null,
    onLabelId = '',
    id = '',
    onChange,
    containerClass = '',
  } = props ?? {}

  return (
    <div id={`${id}-container`} className={clsx('flex', styles.alwaysOn, containerClass)}>
      <p
        className="pe-3"
        style={{
          color: checked ? 'var(--bs-body-color)' : 'var(--bs-secondary-color)',
        }}
      >
        {onLabel || <FormattedMessage id={onLabelId} />}
      </p>
      <Toggle
        id={id}
        checked={!checked} // since 'on' label is always on the left we have to reverse the checked value for the Toggle component and revert it back onChange
        onChange={(value) => onChange(!value)}
        labelText=""
        className="switch mb-3 pe-2"
      />

      <p
        className="ps-3"
        style={{
          color: !checked ? 'var(--bs-body-color)' : 'var(--bs-secondary-color)',
        }}
      >
        {offLabel || <FormattedMessage id={offLabelId} />}
      </p>
    </div>
  )
}

TwoOptionToggle.propTypes = propTypes

export default TwoOptionToggle
